import { DeleteFilled, LoadingOutlined } from '@ant-design/icons'
import { DataItem, EditSaveButton, GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Col, Popconfirm, Row, Switch, Tooltip, Form } from 'antd'
import React, { useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'

export function TankDescriptionRow({
  tank,
  canEditStores,
  editing,
  setEditing,
  loading,
  handleDelete,
  form,
  canEditHolds,
}) {
  useEffect(() => {
    form.setFieldsValue({ ...tank })
  }, [tank])
  const hasCertificateExpired = useMemo(() => tank?.store_out_of_compliance, [tank?.store_out_of_compliance])
  const hasHold = tank?.compliance_hold
  return (
    <Vertical verticalCenter>
      <Horizontal verticalCenter>
        <Vertical className={'mt-1'}>
          <Link
            target='_blank'
            to={`/admin/sites?${new URLSearchParams({
              store_number: tank.store_number,
            })}`}
          >
            {tank.store_number}
          </Link>
        </Vertical>
        <Horizontal verticalCenter justifyContent={'flex-end'} className={'mr-4'}>
          <Texto className={'mr-2 mt-1'}>Compliance Hold</Texto>
          {hasCertificateExpired ? (
            <Tooltip title={'UST Certification Expired'}>
              <Switch defaultChecked={true} className={'error-switch'} disabled={true} />
            </Tooltip>
          ) : (
            <Form.Item name='compliance_hold'>
              <Switch defaultChecked={hasHold} className={'error-switch'} disabled={!canEditHolds || !editing} />
            </Form.Item>
          )}
        </Horizontal>
        <HandleLoadEdit
          loading={loading}
          canEditStores={canEditStores}
          editing={editing}
          setEditing={setEditing}
          handleDelete={handleDelete}
          tank={tank}
          form={form}
        />
      </Horizontal>
      <Horizontal>
        <Texto category='h3' className='pt-2'>{`Tank ID # ${tank.tank_id}`}</Texto>
      </Horizontal>
    </Vertical>
  )
}

function HandleLoadEdit({ loading, canEditStores, editing, setEditing, handleDelete, tank }) {
  if (loading) {
    return (
      <Vertical verticalCenter alignItems={'flex-end'}>
        <LoadingOutlined />
      </Vertical>
    )
  }
  if (canEditStores) {
    return (
      <Horizontal verticalCenter alignItems={'flex-end'}>
        {editing && !loading && (
          <Popconfirm
            title={`Are you sure you want to delete ${tank.tank_id}?`}
            onConfirm={(e) => {
              e.preventDefault()
              handleDelete(tank.store_id, tank.tank_id)
            }}
            okText='Yes'
            cancelText='No'
          >
            <GraviButton error icon={<DeleteFilled />} />
          </Popconfirm>
        )}
        {editing && (
          <Vertical>
            <GraviButton onClick={() => setEditing(false)} appearance='outline' buttonText='Cancel' className='ml-3' />
          </Vertical>
        )}
        <EditSaveButton extraClasses=' ml-3' editing={editing} disabled={loading} onEdit={() => setEditing(true)} />
      </Horizontal>
    )
  }
}
